import React from 'react';
import MoneyInput from 'components/MoneyInput';
import { useRateControllerContext } from '../rateController/RateControllerContext';

type Props = {
  source: string;
};

export const BlendedRateCentsInput = ({ source }: Props) => {
  const { setBlendedRate } = useRateControllerContext();

  return (
    <MoneyInput
      source={`${source}.blended_rate_cents`}
      label="12hr Charge Rate"
      onChange={(event) => setBlendedRate(event.target.value)}
    />
  );
};
